import defaultLogo from '../../assets/logos/taia_logo.png';
import uckLogo from '../../assets/logos/uck_logo.png';

const logos: Record<string, string> = {
    default: defaultLogo,
    uck: uckLogo,
};

export function getLogo(clientTheme: string): string {
    return logos[clientTheme] || logos.default;
}

export function hasMainLogo(clientTheme: string): boolean {
    return clientTheme === 'default';
}

export function hasNavBarLogo(clientTheme: string): boolean {
    return clientTheme === 'uck';
}